import {
  CREATE_CONTENT,
  DELETE_CONTENT,
  LOGIN,
  LOGOUT,
  ORDER_CONTENT,
  TRANSITION_WORKFLOW,
  UPDATE_CONTENT,
} from '@plone/volto/constants/ActionTypes';

const EDITOR_SUCCESS_ACTIONS = [
  `${CREATE_CONTENT}_SUCCESS`,
  `${UPDATE_CONTENT}_SUCCESS`,
  `${DELETE_CONTENT}_SUCCESS`,
  `${ORDER_CONTENT}_SUCCESS`,
  `${TRANSITION_WORKFLOW}_SUCCESS`,
  `${LOGIN}_SUCCESS`,
  `${LOGOUT}_SUCCESS`,
];

const CLEAR_NAVIGATION_REFRESH = 'CLEAR_NAVIGATION_REFRESH';

const initialState = {
  needsNavigationRefresh: true,
};

export default function refresh_navigation(state = initialState, action) {
  if (EDITOR_SUCCESS_ACTIONS.includes(action.type)) {
    return {
      ...state,
      needsNavigationRefresh: true,
    };
  }

  switch (action.type) {
    case CLEAR_NAVIGATION_REFRESH:
      return {
        ...state,
        needsNavigationRefresh: false,
      };

    default:
      return state;
  }
}
